import React, { Component } from "react";
import { Grid, Box } from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import { Edit, Delete, Print } from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtCheckBox from "./CustomTool/CtCheckBox";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
//import { fetchLedgerDetail } from './API'
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  get_YMD_from_DMY,
  formatDateTime,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";

class SalesPurchaseSummary extends Component {
  state = {
    Company: [],
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      { id: "bint_srno", label: "Date" },
      { id: "vac_CompanyName", label: "Bill No" },
      { id: "vac_LegderName", label: "Supplier Name" },
      { id: "int_LegderCode", label: "Total" },
      { id: "dec_OpeningBalance", label: "Adv.Payment" },
      { id: "vac_BalanceSheet", label: "Round Off" },
      { id: "vac_trading", label: "Net Payment" },
      { id: "vac_profitloss", label: "Status" },
      { id: "vac_profitloss", label: "Balance" },
      { id: "vac_profitloss", label: "Transaction Type" },
      { id: "vac_profitloss", label: "Pay Mode" },
      { id: "vac_profitloss", label: "Item Detail" },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "SalesPurchaseSummary:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "SalesPurchaseSummary:",
        actionType: "AlertResponsive",
        hide: Number(localStorage.getItem("De")) === 0,
      },
    ],
    keyColumn: [
      "bint_srno",
      "vac_CompanyName",
      "vac_LegderName",
      "vac_LegderType",
      "int_LegderCode",
      "dec_OpeningBalance",
      "vac_BalanceSheet",
      "vac_trading",
      "vac_profitloss",
    ],

    formData: {
      bint_srno: "",
      cmbCompany: "",
      dtpFromDate: "",
      dtpToDate: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };
  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Sales Purchase Summary";
    this.props.setActiveMenu("SalesPurchaseSummary");
    this.onFormLoad();
  }
  //#endregion Component
  //#endregion handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleARDonActionClick = (values) => {
    // console.log('values', values)
    const bint_srno = values[0].value,
      cmbCompanyName = values[1].value,
      txtLegderName = values[2].value,
      cmbLegderType = values[3].value,
      txtLegderCode = values[4].value,
      txtOpeningBalance = values[5].value,
      cmbBalanceSheet = values[6].value,
      chktrading = values[7].value,
      chkprofitloss = values[8].value,
      actionName = values[0].actionName;
    if (actionName === "Edit") {
      this.setState({
        formData: {
          ...this.state.formData,
          bint_srno,
          cmbCompanyName,
          txtLegderName,
          cmbLegderType,
          txtLegderCode,
          txtOpeningBalance,
          cmbBalanceSheet,
          chktrading,
          chkprofitloss,
        },
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete  : " + bint_srno + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteLedgerDetail(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      let rows = this.state.rows.filter((row) => {
        if (
          row.bint_srno !== bint_srno &&
          row.vac_CompanyName !== cmbCompanyName &&
          row.vac_LegderName !== txtLegderName &&
          row.vac_LegderType !== cmbLegderType &&
          row.int_LegderCode !== txtLegderCode &&
          row.dec_OpeningBalance !== txtOpeningBalance &&
          row.vac_BalanceSheet !== cmbBalanceSheet &&
          row.vac_trading !== chktrading &&
          row.vac_profitloss !== chkprofitloss
        )
          return row;
      });
      const rowsCount = rows.length;
      this.setState({ rows, rowsCount });
    }
  };
  //#region handle
  onFormLoad = () => {
    let dtpFromDate = get_30DaysBack_FromCurrentDate(),
      dtpToDate = get_YMD_from_SYS(new Date());
    this.setState({
      formData: {
        ...this.state.formData,
        dtpFromDate,
        dtpToDate,
      },
    });
  };

  validateLedgerDetail = () => {
    let result = false;
    if (this.state.formData.cmbCompanyName.length <= 0) {
      this.props.toastErrorMsg("Enter Company Name", "cmbCompanyName");
    } else if (this.state.formData.txtLegderName.length <= 0) {
      this.props.toastErrorMsg("Enter Ledger Name", "txtLegderName");
    } else if (this.state.formData.cmbLegderType.length <= 0) {
      this.props.toastErrorMsg("Enter Ledger Type", "cmbLegderType");
    } else if (this.state.formData.txtLegderCode.length <= 0) {
      this.props.toastErrorMsg("Enter Ledger Code", "txtLegderCode");
    } else if (this.state.formData.txtOpeningBalance.length <= 0) {
      this.props.toastErrorMsg("Enter Opening sBalance", "txtOpeningBalance");
    } else if (
      this.state.formData.cmbBalanceSheet <= 0 &&
      this.state.formData.chktrading <= 0 &&
      this.state.formData.chkprofitloss <= 0
    ) {
      this.props.toastErrorMsg(
        "Enter Balance sheet Or Trading Or Profit & Loss",
        "txtLegderCode"
      );
    } else {
      result = true;
    }
    return result;
  };
  // getInfo = () => {
  //     let dataLoadStatus = false
  //     this.setState({ dataLoadStatus }, () => {
  //         const reqData = {
  //             'Op': 'LegderDetailList',
  //         }
  //         fetchLedgerDetail(reqData)
  //             .then(res => {
  //                 dataLoadStatus = true
  //                 let rows = res.data.LegderDetailList,
  //                     rowsCount = rows.length
  //                 this.setState({
  //                     dataLoadStatus,
  //                     rows, rowsCount
  //                 })
  //             })
  //             .catch(error => {
  //                 console.log('Unknown error occurred in onFormLoad.', error)
  //             })
  //     })
  // }
  clearInfo = () => {
    const bint_srno = "",
      cmbCompanyName = "",
      txtLegderName = "",
      cmbLegderType = "",
      txtLegderCode = "",
      txtOpeningBalance = "",
      cmbBalanceSheet = "",
      chktrading = "",
      chkprofitloss = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          bint_srno,
          cmbCompanyName,
          txtLegderName,
          cmbLegderType,
          txtLegderCode,
          txtOpeningBalance,
          cmbBalanceSheet,
          chktrading,
          chkprofitloss,
        },
      },
      () => {
        document.getElementById("cmbCompanyName").focus();
      }
    );
  };

  // SaveLedgerDetail = () => {
  //     if (this.validateLedgerDetail()) {
  //         const dataLoadStatus = false
  //         this.props.notifyProcessing()
  //         this.setState({ dataLoadStatus }, () => {
  //             const reqData = {
  //                 'Op': 'SaveLegderDetail',
  //                 bint_srno: this.state.formData.bint_srno,
  //                 vac_CompanyName: this.state.formData.cmbCompanyName,
  //                 vac_LegderName: this.state.formData.txtLegderName,
  //                 vac_LegderType: this.state.formData.cmbLegderType,
  //                 int_LegderCode: this.state.formData.txtLegderCode,
  //                 dec_OpeningBalance: this.state.formData.txtOpeningBalance,
  //                 vac_BalanceSheet: this.state.formData.cmbBalanceSheet,
  //                 vac_trading: this.state.formData.chktrading,
  //                 vac_profitloss: this.state.formData.chkprofitloss,
  //             }
  //             fetchLedgerDetail(reqData)
  //                 .then(res => {
  //                     this.props.updateProcessing(res.data.msgType, res.data.message)
  //                     if (res.data.msgType === 'success') {
  //                         this.getInfo()
  //                         this.clearInfo(true)
  //                     }
  //                 })
  //                 .catch(error => {
  //                     console.log('Unknown error occurred in SaveLedgerDetail.', error)
  //                 })
  //         })

  //     }
  // }

  // DeleteLedgerDetail = (bint_srno) => {
  //     this.props.notifyProcessing()
  //     this.setState({ dataLoadStatus: false }, () => {
  //         const reqData = {
  //             'Op': 'DeleteLegderDetail',
  //             'bint_srno': bint_srno
  //         }
  //         fetchLedgerDetail(reqData)
  //             .then(res => {
  //                 this.props.updateProcessing(res.data.msgType, res.data.message)
  //                 if (res.data.msgType === 'success') {
  //                     this.setState({ ARD: null }, () => { this.getInfo() })
  //                 } else {
  //                     this.setState({ dataLoadStatus: true })
  //                 }
  //             })
  //             .catch(error => {
  //                 this.props.updateProcessing('error', 'Unknown error occurred in delete DeleteLedgerDetail. ' + error)
  //             })
  //     })
  //     return false
  // }
  // //#endregion function

  render() {
    let rows = this.state.searchOpen ? this.state.searchRows : this.state.rows;
    let rowsCount = this.state.searchOpen
      ? this.state.searchRowsCount
      : this.state.rowsCount;

    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Sales Purchase Summary</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmb
                  id="cmbCompany"
                  label="Company"
                  value={this.state.formData.cmbCompany}
                  handleOnChange={this.handleOnChange}
                  items={this.state.Company}
                  width={150}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpFromDate"
                  label="From Date"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpFromDate}
                  value={this.state.formData.dtpFromDate}
                  onKeyDown={this.props.onKeyDown}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtDtp
                  id="dtpToDate"
                  label="To Date"
                  width="150"
                  handleOnChange={this.handleOnChange}
                  defaultValue={this.state.formData.dtpToDate}
                  value={this.state.formData.dtpToDate}
                  onKeyDown={this.props.onKeyDown}
                  // disabled={this.state.disabledProfileData.DOBDS}
                />
              </Grid>
              <Grid item>
                <CtBtn label="View Report" />
              </Grid>
              <Grid item>
                <CtBtn label="Generate Excel" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(withRouter(SalesPurchaseSummary));
